import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "delivery-detail" }
const _hoisted_2 = { class: "delivery-detail__header" }
const _hoisted_3 = { class: "delivery-detail__order-info-list" }
const _hoisted_4 = { class: "delivery-detail__order-info-list-item" }
const _hoisted_5 = { class: "delivery-detail__order-info-title" }
const _hoisted_6 = { class: "delivery-detail__order-info-description" }
const _hoisted_7 = { class: "delivery-detail__order-info-list-item" }
const _hoisted_8 = { class: "delivery-detail__order-info-title" }
const _hoisted_9 = { class: "delivery-detail__order-info-description" }
const _hoisted_10 = { class: "delivery-detail__order-info-list-item" }
const _hoisted_11 = { class: "delivery-detail__order-info-title" }
const _hoisted_12 = { class: "delivery-detail__order-info-description" }
const _hoisted_13 = { class: "delivery-detail__recipient-info" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = { class: "delivery-detail__list u-reset" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_spinner = _resolveComponent("spinner")!
  const _component_icon = _resolveComponent("icon")!
  const _component_simple_button = _resolveComponent("simple-button")!
  const _component_product_list_item_lite = _resolveComponent("product-list-item-lite")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["delivery-detail__buttons button-group button-group--horizontal", _ctx.buttonGroupClasses])
    }, [
      _createVNode(_component_simple_button, {
        facets: ['primary', 'round'],
        disabled: _ctx.isAddingItemsToCart,
        onClick: _ctx.onAddItemsToCart
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.translate('shop__order__add_products_to_cart__button', {
            amount: _ctx.productsAmount,
          })) + " ", 1),
          (_ctx.isAddingItemsToCart)
            ? (_openBlock(), _createBlock(_component_spinner, { key: 0 }))
            : (_openBlock(), _createBlock(_component_icon, {
                key: 1,
                name: "cart",
                size: "medium"
              }))
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ], 2),
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("dl", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("dt", _hoisted_5, _toDisplayString(_ctx.translate('shop__delivery_detail__delivery__date')) + ": ", 1),
          _createElementVNode("dd", _hoisted_6, _toDisplayString(_ctx.formatDateToLocaleDateString(_ctx.delivery.targetDate)), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("dt", _hoisted_8, _toDisplayString(_ctx.translate('shop__delivery_detail__order__date')) + ": ", 1),
          _createElementVNode("dd", _hoisted_9, _toDisplayString(_ctx.guessedOrderDate), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("dt", _hoisted_11, _toDisplayString(_ctx.translate('shop__delivery_detail__order__number')) + ": ", 1),
          _createElementVNode("dd", _hoisted_12, _toDisplayString(_ctx.guessedOrderNumber), 1)
        ])
      ]),
      _createElementVNode("p", _hoisted_13, [
        _createTextVNode(_toDisplayString(_ctx.guessedUsername), 1),
        _hoisted_14,
        _createTextVNode(" " + _toDisplayString(_ctx.delivery.recipient.street), 1),
        _hoisted_15,
        _createTextVNode(" " + _toDisplayString(_ctx.delivery.recipient.zipCode) + " " + _toDisplayString(_ctx.delivery.recipient.city), 1)
      ])
    ]),
    _createElementVNode("ul", _hoisted_16, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.delivery.items, (item) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "delivery-detail__item",
          key: item.sku
        }, [
          _createVNode(_component_product_list_item_lite, {
            "product-id": item?.sku || '',
            title: item?.name || '',
            "product-number": item?.sku,
            "batch-number": item.customData?.batchNumber,
            "expiration-date": item.customData?.expirationDate,
            "show-counter": true,
            "image-sources": item.image?.sources || [],
            "is-counter-enabled": false,
            quantity: item.quantity,
            "quantity-description": item.quantityUnit,
            unit: item.quantityUnit,
            "unit-code": item.quantityUnit
          }, null, 8, ["product-id", "title", "product-number", "batch-number", "expiration-date", "image-sources", "quantity", "quantity-description", "unit", "unit-code"])
        ]))
      }), 128))
    ])
  ]))
}